import { getCookie, setCookie } from '../../utils/cookie'
import { auth } from '../authentication/authentication.js'
import { useUserStore } from '../../../../store/user.js'

const key = 'thatsup_hide_adblock_popup'

const userStore = useUserStore()
if (!window.canShowAds && !userStore.isLoggedIn && !(getCookie(key) === 'true')) {
    // Dam user got dat adblock on 🤬
    setCookie(key, true, 30)
    auth(null, { variation: 'adblock' })
}
